import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function SingleVerticalCrisis() {
  return (
    <div className="single-vertical-parent">
      <div className="vertical-title">
        <div className="text-900 font-bold text-7xl mb-4 text-center">
          FlexNet Crisis: Reliable Connectivity for Emergency Response
        </div>
        <div className="text-700 text-xl mb-6 text-center line-height-3">
          Empower first responders with resilient, high-speed private 4G/5G
          networks for disaster recovery, public safety, and emergency
          coordination.
        </div>
      </div>
      {/* Hero Section */}
      <div className="grid grid-nogutter surface-section text-800 ">
        <div className="col-12 md:col-6 p-6 text-center md:text-left flex align-items-center">
          <section>
            <span className="block text-6xl font-bold mb-3">
              FlexNet Crisis
            </span>
            <div className="text-6xl text-primary font-bold mb-3">
              Revolutionizing Operations with 5G Connectivity
            </div>
            <p className="mt-0 mb-4 text-700 line-height-3">
              Ensure mission-critical communication with FlexNet's private 4G/5G
              networks. Designed for fast deployment in crisis zones, providing
              secure, reliable connectivity for emergency coordination and
              response.
            </p>
            <button className="flex underline align-items-center mt-4">
              <Link to="/connectivity">Request Demo</Link>
              <FaExternalLinkAlt className="ml-2" />
            </button>
          </section>
        </div>
        <div className="col-12 md:col-6 overflow-hidden">
          <img
            src="https://www.fireapparatusmagazine.com/wp-content/uploads/2024/10/2410FA_mckinzie_p02.png"
            alt="hero-1"
            className="md:ml-auto block md:h-full"
            style={{ clipPath: "polygon(8% 0, 100% 0%, 100% 100%, 0 100%)" }}
          />
        </div>
      </div>

      {/* Key Benefits Section */}
      <div className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center">
        <div className="mb-3 font-bold text-3xl">
          <span className="text-900">Why </span>
          <span className="text-blue-600">FlexNet for Crisis?</span>
        </div>
        <div className="grid justify-center">
          {keyBenefits.map((benefit, index) => (
            <div key={index} className="col-12 md:col-4 mb-4 px-5">
              <span
                className="p-3 shadow-2 mb-3 inline-block surface-card"
                style={{ borderRadius: "10px" }}
              >
                <i className={`${benefit.icon} text-4xl text-blue-500`}></i>
              </span>
              <div className="text-900 text-xl mb-3 font-medium">
                {benefit.title}
              </div>
              <span className="text-700 line-height-3">{benefit.detail}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Use Cases Section */}

      <div className="mb-3 font-bold text-3xl">
        <span className="text-900">FlexNet Crisis </span>
        <span className="text-blue-600">Use Cases</span>
      </div>
      {useCases.map((useCase, index) => (
        <div
          key={index}
          className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center"
        >
          <div className="b-3 font-bold text-2xl mb-3">
            <span className="text-blue-600">Use Case</span>
            {useCase.title}
          </div>
          <div className="text-700 mb-6">{useCase.description}</div>
          <div className="grid">
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">Benefits</div>
              {useCase.benefits.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">
                Devices/Technologies
              </div>
              {useCase.devices.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">
                Applications
              </div>
              {useCase.applications.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <button className="flex underline align-items-center mt-4 vertical-market-link">
              <Link to="/marketplace">Request Access to Marketplace</Link>
              <FaExternalLinkAlt className="ml-2" />
            </button>
          </div>
        </div>
      ))}

      {/* Case Studies Testimonias Section */}
      <div className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center">
        <div className="mb-3 font-bold text-3xl">
          <span className="text-blue-600"> Key Technical Features</span>
        </div>
        <div className="grid justify-center">
          <div className="text-900 text-xl mb-3 font-medium"></div>
          <div className="technical-specifications">
            <div className="text-700 line-height-3 technical-specifications-box text-xl">
              <ul className="list-disc pl-5 mt-3">
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Rapid deployment with FlexBox portable units
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Secure, encrypted communication protocols
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  High-bandwidth support for data, voice, and video
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Low-latency connectivity for real-time coordination
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Seamless integration with existing public safety systems
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Call-to-Action Section */}
      <div className="surface-section text-center py-8">
        <div className="text-900 text-3xl font-bold mb-4">
          Ready to Strengthen Your Crisis Response?
        </div>

        <button className="p-button p-button-raised connectivity-request-demo-button p-3">
          <Link to="contact-page">Get in Touch for a Personalized Demo</Link>
        </button>
      </div>
    </div>
  );
}

const keyBenefits = [
  {
    title: "Rapid Deployment with Portable FlexBox Units",
    detail:
      "Ensure quick and efficient network setup in disaster-struck areas.",
    icon: "pi pi-box",
  },
  {
    title: "Secure, Resilient Communication in Disaster Zones",
    detail: "Maintain uninterrupted communication in critical situations.",
    icon: "pi pi-shield",
  },
  {
    title: "Real-Time Coordination for First Responders",
    detail: "Enable seamless collaboration between emergency teams.",
    icon: "pi pi-users",
  },
  {
    title: "Enhanced Situational Awareness with IoT and Video Analytics",
    detail: "Improve decision-making with real-time monitoring and data.",
    icon: "pi pi-chart-bar",
  },
  {
    title: "Reliable Push-to-Talk (PTT) and Mission-Critical Voice Services",
    detail:
      "Ensure clear and secure voice communication in emergency situations.",
    icon: "pi pi-comments",
  },
];

const useCases = [
  {
    title: " 1: Emergency Response Connectivity",
    description:
      "Deploy portable 5G networks (FlexBox) for rapid communication setup in disaster-struck areas, ensuring connectivity for first responders.",
    benefits: [
      {
        title: "Immediate network availability in remote or damaged areas",
        icon: "pi pi-wifi",
      },
      {
        title:
          "Reliable communication during natural disasters, fires, and floods",
        icon: "pi pi-bolt",
      },
      {
        title: "Support for critical voice, data, and video services",
        icon: "pi pi-video",
      },
    ],
    devices: [
      { title: "FlexBox", icon: "pi pi-box" },
      { title: "PTT Devices", icon: "pi pi-comments" },
      { title: "IoT Gateways", icon: "pi pi-cloud" },
    ],
    applications: [
      { title: "Emergency Communication Networks", icon: "pi pi-desktop" },
    ],
  },
  {
    title: " 2: Mission-Critical Push-to-Talk (PTT) Communication",
    description:
      "Enable secure, real-time voice communication for emergency teams with 4G/5G-enabled PTT devices, ensuring clear coordination even in challenging environments.",
    benefits: [
      {
        title: "Low-latency, high-reliability voice communication",
        icon: "pi pi-phone",
      },
      {
        title: "Enhanced team coordination and situational awareness",
        icon: "pi pi-users",
      },
      {
        title: "Secure channels for sensitive communications",
        icon: "pi pi-lock",
      },
    ],
    devices: [
      { title: "PTT Devices", icon: "pi pi-comments" },
      { title: "Rugged Smartphones", icon: "pi pi-mobile" },
      { title: "FlexNet 4G/5G Portable Trailer", icon: "pi pi-truck" },
    ],
    applications: [
      { title: "Public Safety Communication Platforms", icon: "pi pi-desktop" },
    ],
  },
  {
    title: " 3: Disaster Site Video Surveillance",
    description:
      "Utilize drones and body-worn cameras with live video feeds for real-time situational awareness during search and rescue missions.",
    benefits: [
      { title: "Rapid assessment of disaster zones", icon: "pi pi-eye" },
      {
        title: "Enhanced decision-making with real-time visuals",
        icon: "pi pi-chart-line",
      },
      { title: "Improved safety for response teams", icon: "pi pi-shield" },
    ],
    devices: [
      { title: "Drones", icon: "pi pi-send" },
      { title: "Body Cameras", icon: "pi pi-camera" },
      { title: "Video Analytics Platforms", icon: "pi pi-microchip " },
    ],
    applications: [
      { title: "Emergency Monitoring Systems", icon: "pi pi-desktop" },
    ],
  },
  {
    title: " 4: IoT-Enabled Search and Rescue Operations",
    description:
      "Deploy IoT sensors to detect survivors, monitor environmental conditions, and track assets in real-time during rescue operations.",
    benefits: [
      {
        title: "Faster location of survivors using sensor data",
        icon: "pi pi-map",
      },
      {
        title: "Real-time monitoring of hazardous conditions",
        icon: "pi pi-exclamation-circle",
      },
      {
        title: "Improved resource allocation for rescue efforts",
        icon: "pi pi-cog",
      },
    ],
    devices: [
      { title: "IoT Sensors", icon: "pi pi-cloud" },
      { title: "Environmental Monitoring Devices", icon: "pi pi-sun" },
      { title: "GPS Trackers", icon: "pi pi-map" },
    ],
    applications: [
      { title: "Search and Rescue Platforms", icon: "pi pi-desktop" },
    ],
  },
  {
    title: " 5: Temporary Networks for Large-Scale Public Events",
    description:
      "Set up temporary, secure 5G networks for event management, ensuring reliable connectivity for emergency services during large gatherings.",
    benefits: [
      {
        title: "High-capacity, low-latency networks for crowd management",
        icon: "pi pi-users",
      },
      { title: "Enhanced emergency response readiness", icon: "pi pi-bell" },
      {
        title: "Secure communication channels for event staff",
        icon: "pi pi-lock",
      },
    ],
    devices: [
      { title: "FlexNet 4G/5G Portable Trailer", icon: "pi pi-truck" },
      { title: "CPE Devices", icon: "pi pi-wifi" },
      { title: "Edge Servers", icon: "pi pi-server" },
    ],
    applications: [
      {
        title: "Event Security and Emergency Communication",
        icon: "pi pi-desktop",
      },
    ],
  },
];
